const dynamicTextElement = document.querySelector('.for-what__dynamic-text');
if (dynamicTextElement !== null) {
    const texts = [
        'разместить информацию на официальном сайте',
        'автоматизировать проведение приемной кампании',
        'провести анкетирование респондентов в рамках ВСОКО',
        'рассчитать показатели аккредитационного мониторинга',
        'сформировать формы для государственной аккредитации',
    ];
    let currentIndex = 0;

    dynamicTextElement.textContent = texts[currentIndex];
    dynamicTextElement.classList.add('visible');

    function changeText() {
        dynamicTextElement.classList.remove('visible');
        setTimeout(() => {
            currentIndex = (currentIndex + 1) % texts.length;
            dynamicTextElement.textContent = texts[currentIndex];
            dynamicTextElement.classList.add('visible');
        }, 1000);
    }

    setInterval(changeText, 3000);
}
